import { ComponentProps, FC, PropsWithChildren } from 'react';

import { Box } from '@bonusly/design-system';

interface UserSpotlightCardShellProps extends PropsWithChildren {
	/**
	 * Optional override for the inner "content" card padding (the solid surface).
	 */
	innerPadding?: ComponentProps<typeof Box>['p'];
}

export const UserSpotlightCardShell: FC<UserSpotlightCardShellProps> = ({ children, innerPadding = { base: 8, md: '60px' } }) => {
	return (
		<Box
			borderRadius="3xl"
			bg="bg.minipage"
			backdropFilter="blur(20px)"
			p="15px"
			border="1.5px solid"
			borderColor="bg.surface"
			sx={{
				WebkitBackdropFilter: 'blur(20px)',
				// Force light mode shadow in both modes (dark mode shadow is too strong for spotlight's bright background)
				boxShadow: '0 0 1px 0 #43485614, 0 2px 4px 0 #43485614, 0 9px 8px 0 #43485614, 0 21px 12px 0 #4348560a, 0 37px 14px 0 #43485603',
			}}
		>
			<Box bg="bg.surface" borderRadius="2xl" p={innerPadding} display="flex" flexDirection="column" justifyContent="center" position="relative">
				{children}
			</Box>
		</Box>
	);
};
